import type { ApplicationEnvInitialState } from './appEnv';
import type { AppNotificationsInitialState } from 'redux/reducers/appNotifications';
import type { AppointmentsState } from 'redux/reducers/appointments';
import type { CustomizerInitialState } from './customizer/customizer';
import type { LoginInitialState } from './auth/loginReducer';
import type { MemberInitialState } from 'redux/reducers/member';
import type { PartsAndLaborInitialState } from 'redux/reducers/parts-and-labor-guide';
import type { PrintingState } from './printing';
import type { QuotingInitialState } from 'redux/reducers/quoting';
import type { SidebarInitialState } from 'redux/reducers/sidebar';

import appNotifications from 'redux/reducers/appNotifications';
import appointments from 'redux/reducers/appointments';
import auth from 'redux/reducers/auth';
import { combineReducers } from 'redux';
import customizer from 'redux/reducers/customizer';
import member from 'redux/reducers/member';
import partsAndLaborGuide from 'redux/reducers/parts-and-labor-guide';
import quoting from 'redux/reducers/quoting';
import repairOrders from 'redux/reducers/repair-orders';
import scale from 'redux/reducers/scale';
import sidebar from 'redux/reducers/sidebar';

import appEnv from './appEnv';
import printing from './printing';

const rootReducer = combineReducers({
  appNotifications,
  appEnv,
  appointments,
  auth,
  customizer,
  member,
  partsAndLaborGuide,
  printing,
  quoting,
  repairOrders,
  scale,
  sidebar,
}) as any;

export type RootState = {
  appNotifications: AppNotificationsInitialState;
  appEnv: ApplicationEnvInitialState;
  appointments: AppointmentsState;
  auth: {
    login: LoginInitialState;
  };
  customizer: {
    customizer: CustomizerInitialState;
  };
  member: MemberInitialState;
  partsAndLaborGuide: PartsAndLaborInitialState;
  printing: PrintingState;
  quoting: QuotingInitialState;
  repairOrders: any; // TODO can we eliminate this
  scale: any; // TODO this too
  sidebar: SidebarInitialState;
};
export type GetState = () => RootState;

export default rootReducer;
